import { getCreateServiceLogUrl } from 'generatedTypes/asset/services/asset-service-log-controller';
import { useState } from 'react';
import { normalizePayload } from 'utils/normalizePayload';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import type { AssetServiceLogResponse, CreateServiceLog, UseServiceLog } from './types';

const useServiceLog = (): UseServiceLog => {
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedPost } = useFetch();
    const { withRetry } = useRetry();
    const { SAVE_FAILED } = useTranslation();

    const createServiceLog: CreateServiceLog = async ({ assetId, serviceLog }) => {
        try {
            setIsLoading(true);
            const url = getCreateServiceLogUrl(assetId);

            return await withRetry(
                () =>
                    authenticatedPost<AssetServiceLogResponse>(
                        url,
                        JSON.stringify(normalizePayload({ ...serviceLog }))
                    ),
                SAVE_FAILED,
                () => createServiceLog({ assetId, serviceLog })
            );
        } finally {
            setIsLoading(false);
        }
    };

    return { createServiceLog, isLoading };
};

export default useServiceLog;
